<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    scoreMax: 0,
    return: {
      val: 0.0,
    },
  }),

  computed: {
    ...mapGetters("admin-contract-statistics", [
      "GET_PAIDS",
      "GET_PAIDS_1KURS",
      "GET_PAIDS_2KURS",
    ]),
  },

  created() {
    this.INIT_PAIDS();
    this.INIT_PAIDS_1KURS();
    this.INIT_PAIDS_2KURS();
  },

  methods: {
    ...mapActions("admin-contract-statistics", [
      "INIT_PAIDS",
      "INIT_PAIDS_1KURS",
      "INIT_PAIDS_2KURS",
    ]),

    addScript(id, src, text) {
      if (document.getElementById(id) || (!src && !text)) return;

      const script = document.createElement("script");
      script.setAttribute("type", "text/javascript");
      if (src) script.setAttribute("src", src);
      else script.textContent = text;
      script.setAttribute("id", id);
      document.head.appendChild(script);
    },

    getPercent(total_summa, total_paid_summa) {
      return total_summa > 0
        ? parseFloat((total_paid_summa * 100) / total_summa).toFixed(2)
        : 0;
    },
  },
};
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="pt-9">
        <div class="-cart">
          <div
            class="title accent--text text-center pb-5"
            v-text="$t('Paid information')"
          />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left"><b>Fakultet</b></th>
                  <th class="text-left"><b>Jami(100%)</b></th>
                  <th class="text-left"><b>To`langan summa</b></th>
                  <th class="text-left"><b>To`langan(%)</b></th>
                  <th class="text-left"><b>Jami Uzb(100%)</b></th>
                  <th class="text-left"><b>Uzb To`langan summa</b></th>
                  <th class="text-left"><b>Uzb To`langan(%)</b></th>
                  <!--                  <th class="text-left"><b>Kunduzgi(%)</b></th>
                  <th class="text-left"><b>Kechki(%)</b></th>
                  <th class="text-left"><b>Sirtqi(%)</b></th>-->
                  <th class="text-left"><b>Jami Rus(100%)</b></th>
                  <th class="text-left"><b>Rus To`langan summa</b></th>
                  <th class="text-left"><b>Rus To`langan(%)</b></th>
                  <!--                  <th class="text-left"><b>Kunduzgi(%)</b></th>
                  <th class="text-left"><b>Kechki(%)</b></th>
                  <th class="text-left"><b>Sirtqi(%)</b></th>-->
                </tr>
              </thead>
              <tbody>
                <!--              Long allSumma;
              Long allPaidSumma;
              Long allUzSumma;
              Long allUzPaidSumma;
              Long dailyUzSumma;
              Long dailyUzPaidSumma;
              Long eveningUzSumma;
              Long eveningUzPaidSumma;
              Long extramuralUzSumma;
              Long extramuralUzPaidSumma;
              Long allRuSumma;
              Long allRuPaidSumma;
              Long dailyRuSumma;
              Long dailyRuPaidSumma;
              Long eveningRuSumma;
              Long eveningRuPaidSumma;
              Long extramuralRuSumma;
              Long extramuralRuPaidSumma;-->
                <tr v-for="(item, i) in GET_PAIDS" :key="i">
                  <td>
                    <b>{{ item.facultyName }}</b>
                  </td>
                  <td>
                    <b>{{ item.allSumma }}</b>
                  </td>
                  <td>
                    {{ item.allPaidSumma }}
                  </td>
                  <td>{{ getPercent(item.allSumma, item.allPaidSumma) }} %</td>
                  <td>
                    <b>{{ item.allUzSumma }}</b>
                  </td>
                  <td>
                    {{ item.allUzPaidSumma }}
                  </td>
                  <td>
                    {{ getPercent(item.allUzSumma, item.allUzPaidSumma) }} %
                  </td>
                  <!--                  <td>{{ item.dailyUzPaidSumma }}</td>
                  <td>{{ item.eveningUzPaidSumma }}</td>
                  <td>{{ item.extramuralUzPaidSumma }}</td>-->
                  <td>
                    <b>{{ item.allRuSumma }}</b>
                  </td>
                  <td>{{ item.allRuPaidSumma }}</td>
                  <td>
                    {{ getPercent(item.allRuSumma, item.allRuPaidSumma) }} %
                  </td>
                  <!--                  <td>{{ item.dailyRuPaidSumma }}</td>
                  <td>{{ item.eveningRuPaidSumma }}</td>
                  <td>{{ item.extramuralRuPaidSumma }}</td>-->
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
      <v-col cols="12" class="pt-9">
        <div class="-cart">
          <div
            class="title accent--text text-center pb-5"
            v-text="$t('Paid information 1 kurs')"
          />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left"><b>Fakultet</b></th>
                  <th class="text-left"><b>Jami(100%)</b></th>
                  <th class="text-left"><b>To`langan summa</b></th>
                  <th class="text-left"><b>To`langan(%)</b></th>
                  <th class="text-left"><b>Jami Uzb(100%)</b></th>
                  <th class="text-left"><b>Uzb To`langan summa</b></th>
                  <th class="text-left"><b>Uzb To`langan(%)</b></th>
                  <!--                  <th class="text-left"><b>Kunduzgi(%)</b></th>
                <th class="text-left"><b>Kechki(%)</b></th>
                <th class="text-left"><b>Sirtqi(%)</b></th>-->
                  <th class="text-left"><b>Jami Rus(100%)</b></th>
                  <th class="text-left"><b>Rus To`langan summa</b></th>
                  <th class="text-left"><b>Rus To`langan(%)</b></th>
                  <!--                  <th class="text-left"><b>Kunduzgi(%)</b></th>
                <th class="text-left"><b>Kechki(%)</b></th>
                <th class="text-left"><b>Sirtqi(%)</b></th>-->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in GET_PAIDS_1KURS" :key="i">
                  <td>
                    <b>{{ item.facultyName }}</b>
                  </td>
                  <td>
                    <b>{{ item.allSumma }}</b>
                  </td>
                  <td>
                    {{ item.allPaidSumma }}
                  </td>
                  <td>{{ getPercent(item.allSumma, item.allPaidSumma) }} %</td>
                  <td>
                    <b>{{ item.allUzSumma }}</b>
                  </td>
                  <td>
                    {{ item.allUzPaidSumma }}
                  </td>
                  <td>
                    {{ getPercent(item.allUzSumma, item.allUzPaidSumma) }} %
                  </td>
                  <!--                  <td>{{ item.dailyUzPaidSumma }}</td>
                <td>{{ item.eveningUzPaidSumma }}</td>
                <td>{{ item.extramuralUzPaidSumma }}</td>-->
                  <td>
                    <b>{{ item.allRuSumma }}</b>
                  </td>
                  <td>{{ item.allRuPaidSumma }}</td>
                  <td>
                    {{ getPercent(item.allRuSumma, item.allRuPaidSumma) }} %
                  </td>
                  <!--                  <td>{{ item.dailyRuPaidSumma }}</td>
                <td>{{ item.eveningRuPaidSumma }}</td>
                <td>{{ item.extramuralRuPaidSumma }}</td>-->
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
      <v-col cols="12" class="pt-9">
        <div class="-cart">
          <div
            class="title accent--text text-center pb-5"
            v-text="$t('Paid information 2 kurs')"
          />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left"><b>Fakultet</b></th>
                  <th class="text-left"><b>Jami(100%)</b></th>
                  <th class="text-left"><b>To`langan summa</b></th>
                  <th class="text-left"><b>To`langan(%)</b></th>
                  <th class="text-left"><b>Jami Uzb(100%)</b></th>
                  <th class="text-left"><b>Uzb To`langan summa</b></th>
                  <th class="text-left"><b>Uzb To`langan(%)</b></th>
                  <!--                  <th class="text-left"><b>Kunduzgi(%)</b></th>
              <th class="text-left"><b>Kechki(%)</b></th>
              <th class="text-left"><b>Sirtqi(%)</b></th>-->
                  <th class="text-left"><b>Jami Rus(100%)</b></th>
                  <th class="text-left"><b>Rus To`langan summa</b></th>
                  <th class="text-left"><b>Rus To`langan(%)</b></th>
                  <!--                  <th class="text-left"><b>Kunduzgi(%)</b></th>
              <th class="text-left"><b>Kechki(%)</b></th>
              <th class="text-left"><b>Sirtqi(%)</b></th>-->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in GET_PAIDS_2KURS" :key="i">
                  <td>
                    <b>{{ item.facultyName }}</b>
                  </td>
                  <td>
                    <b>{{ item.allSumma }}</b>
                  </td>
                  <td>
                    {{ item.allPaidSumma }}
                  </td>
                  <td>{{ getPercent(item.allSumma, item.allPaidSumma) }} %</td>
                  <td>
                    <b>{{ item.allUzSumma }}</b>
                  </td>
                  <td>
                    {{ item.allUzPaidSumma }}
                  </td>
                  <td>
                    {{ getPercent(item.allUzSumma, item.allUzPaidSumma) }} %
                  </td>
                  <!--                  <td>{{ item.dailyUzPaidSumma }}</td>
              <td>{{ item.eveningUzPaidSumma }}</td>
              <td>{{ item.extramuralUzPaidSumma }}</td>-->
                  <td>
                    <b>{{ item.allRuSumma }}</b>
                  </td>
                  <td>{{ item.allRuPaidSumma }}</td>
                  <td>
                    {{ getPercent(item.allRuSumma, item.allRuPaidSumma) }} %
                  </td>
                  <!--                  <td>{{ item.dailyRuPaidSumma }}</td>
              <td>{{ item.eveningRuPaidSumma }}</td>
              <td>{{ item.extramuralRuPaidSumma }}</td>-->
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
.-cart {
  background: rgba(154, 154, 154, 0.2);
  border-radius: 10px;
  padding: 30px;
  height: 100%;
}

.g-chart {
  max-width: 276px;
  margin: 0 auto;
}

.count-with-icon {
  flex: 1;
  text-align: center;
  display: flex;
  justify-content: space-around;
  border-left: 1px solid #888888;
}
</style>
